import React from 'react';
import { Play, X, BookOpen, Star, Clock } from 'lucide-react';
import { LatteButton } from '../common';

const OnboardingWelcomeModal = ({ isOpen, onStart, onSkip, userName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onSkip();
      }
    }}>
      <div className="modal modal-lg">
        {/* 헤더 영역 */}
        <div className="modal-header-gradient">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-white mb-1">
                환영합니다, {userName}님! 🎉
              </h2>
              <p className="text-latte-lightest opacity-90">
                Latte is와 함께 시작해보세요
              </p>
            </div>
            <button
              onClick={onSkip}
              className="modal-close-btn-light"
              title="건너뛰기"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* 본문 영역 */}
        <div className="modal-body">
          {/* 아이콘과 제목 */}
          <div className="text-center mb-6">
            <div className="modal-icon-wrapper default mb-4">
              <Star className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              처음 사용하시는군요!
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Latte is의 핵심 기능들을 빠르게 둘러보는 <strong className="text-latte-primary">가이드 투어</strong>를 제공합니다. 
              대시보드에서 시작해서 AI 컨설팅, 이력서 편집까지 전체 과정을 체험할 수 있어요.
            </p>
          </div>

          {/* 단계 설명 */}
          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3">
              <div className="onboarding-step-number">
                <span>1</span>
              </div>
              <span className="text-gray-700 text-sm">대시보드 주요 기능 확인</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="onboarding-step-number">
                <span>2</span>
              </div>
              <span className="text-gray-700 text-sm">AI 컨설팅 페이지 둘러보기</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="onboarding-step-number">
                <span>3</span>
              </div>
              <span className="text-gray-700 text-sm">이력서 편집 기능 체험</span>
            </div>
          </div>

          {/* 소요 시간 안내 */}
          <div className="bg-latte-lightest border border-latte-light rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 text-latte-dark">
              <Clock className="w-4 h-4" />
              <span className="text-sm font-medium">
                약 3-5분 소요 • 전체 플로우 체험 • 언제든 건너뛰기 가능
              </span>
            </div>
          </div>

          {/* 액션 버튼 */}
          <div className="flex gap-3">
            <LatteButton
              onClick={onSkip}
              variant="secondary"
              size="lg"
              className="flex-1"
            >
              나중에 하기
            </LatteButton>
            <LatteButton
              onClick={onStart}
              variant="gradient"
              size="lg"
              className="flex-1"
            >
              <Play className="w-4 h-4" />
              시작하기
            </LatteButton>
          </div>

          {/* 가이드 링크 */}
          <div className="mt-4 text-center">
            <button
              onClick={() => {
                window.open('/guide', '_blank', 'noopener,noreferrer');
                onSkip();
              }}
              className="text-sm text-latte-primary hover:text-latte-dark transition-colors inline-flex items-center gap-1"
              title="상세 가이드 (새 창)"
            >
              <BookOpen className="w-4 h-4" />
              대신 상세 가이드 보기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingWelcomeModal;